import React, { useState } from 'react';
import AgentBanner from './AgentBanner';
import EmbeddedAgentChat from './EmbeddedAgentChat';

export { SECTION_AGENTS } from './sectionAgentConfig';
export { default as AgentBanner } from './AgentBanner';
export { default as EmbeddedAgentChat } from './EmbeddedAgentChat';
export { default as MicButton } from './MicButton';

export default function SectionAgent({ section }) {
  const [chatOpen, setChatOpen] = useState(false);
  return (
    <>
      <AgentBanner section={section} onOpen={() => setChatOpen(true)} />
      <EmbeddedAgentChat
        section={section}
        open={chatOpen}
        onClose={() => setChatOpen(false)}
      />
    </>
  );
}
